/* Модуль реферальной программы и баланса бонусов */
function getReferralId() {
    const user = getUser();
    if (user?.telegramId) return user.telegramId;
    if (user?.refId) return user.refId;

    const tg = window.Telegram?.WebApp;
    if (tg?.initDataUnsafe?.user?.id) {
      return String(tg.initDataUnsafe.user.id);
    }

    let localRefId = localStorage.getItem('meta_local_ref_id');
    if (!localRefId) {
      localRefId = 'u' + Math.floor(100000 + Math.random() * 900000);
      localStorage.setItem('meta_local_ref_id', localRefId);
    }
    return localRefId;
  }

  // Генерация персональной реферальной ссылки в Telegram Mini App
  function getReferralLink() {
    const refId = getReferralId();
    const botUser = window.META_BOT_USERNAME || localStorage.getItem('meta_bot_username') || (typeof BOT_USERNAME !== 'undefined' ? BOT_USERNAME : '');
    if (botUser) {
      return `https://t.me/${botUser}/app?startapp=ref_${refId}`;
    }
    const origin = (window.location && window.location.origin) ? window.location.origin : '';
    return `${origin}/?ref=${refId}`;
  }

  // Генерация Share URL для отправки подруге
  function getShareUrl() {
    const link = getReferralLink();
    const defaultShareText = 'Привет! Делюсь ссылкой на бесплатный 4-дневный интенсив по прикладной метафизике: разборы карт, практики и чек-листы.';
    const text = (typeof SHARE_TEXT !== 'undefined' && SHARE_TEXT) ? SHARE_TEXT : defaultShareText;
    return `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
  }

  // Универсальное копирование в буфер обмена (ПК и мобильные устройства)
  function copyToClipboard(text) {
    if (!text) return Promise.reject(new Error('Empty text'));

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(text).catch(() => fallbackCopy(text));
    }
    return fallbackCopy(text);
  }

  function fallbackCopy(text) {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.fontSize = '16px';
      ta.style.position = 'fixed';
      ta.style.top = `${window.pageYOffset || document.documentElement.scrollTop || 0}px`;
      ta.style.left = '-9999px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      
      // Корректное выделение для iOS WebKit
      ta.focus();
      ta.setSelectionRange(0, 999999);
      
      const successful = document.execCommand('copy');
      document.body.removeChild(ta);
      return successful ? Promise.resolve() : Promise.reject();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  // Всплывающее уведомление
  function showToast(msg, duration = 3000) {
    let toast = document.getElementById('metaGlobalToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'metaGlobalToast';
      toast.style.cssText = 'position:fixed;bottom:75px;left:50%;transform:translateX(-50%) translateY(20px);background:rgba(20,18,20,0.92);color:#FAF8F5;padding:10px 18px;border-radius:12px;font-size:12.5px;font-weight:600;z-index:99999;box-shadow:0 8px 24px rgba(0,0,0,0.3);opacity:0;transition:all 0.25s ease;pointer-events:none;text-align:center;max-width:90%;line-height:1.4;border:1px solid rgba(212,175,110,0.3);';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(20px)';
    }, duration);
  }
  window.showMetaToast = showToast;

  // Шеринг ссылки в Telegram
  function shareInvite() {
    triggerHaptic('medium');
    const link = getReferralLink();

    // Всегда копируем ссылку в буфер обмена для мгновенного результата на ПК и мобильных
    copyToClipboard(link).then(() => {
      showToast('✓ Персональная ссылка скопирована! Отправьте её другу.');
    }).catch(() => {});

    // Визуальный отклик на всех кнопках шеринга на экране
    document.querySelectorAll('#dashboardShareBtn, #referralShareBtn, a.btn-emerald[onclick*="shareInvite"]').forEach(btn => {
      const span = btn.querySelector('span');
      if (span && !btn._origHtml) {
        btn._origHtml = span.innerHTML;
        span.innerHTML = '✓ Ссылка скопирована!';
        setTimeout(() => {
          if (btn._origHtml) {
            span.innerHTML = btn._origHtml;
            delete btn._origHtml;
          }
        }, 2500);
      }
    });

    if (window.Telegram?.WebApp && typeof window.Telegram.WebApp.openTelegramLink === 'function') {
      window.Telegram.WebApp.openTelegramLink(getShareUrl());
    } else {
      window.open(getShareUrl(), '_blank');
    }
  }

  // Получение списка открытых дней (День 1 открыт всегда, остальные дни разблокируются по капельному доступу или рефералам)
  function getUnlockedDays() {
    try {
      if (localStorage.getItem('meta_paid_all_days') === 'true') {
        return [1, 2, 3, 4];
      }
      const u = (typeof getUser === 'function') ? getUser() : null;
      if (u && (u.has_paid || u.hasPaid)) {
        return [1, 2, 3, 4];
      }
      if (typeof isRegistered === 'function' && !isRegistered()) {
        return [];
      }
      // При наличии подтвержденной подписки на закрытый канал - ВСЕ 4 ДНЯ ОТКРЫТЫ СРАЗУ
      if ((typeof isChannelSubscribed === 'function' && isChannelSubscribed()) ||
          localStorage.getItem('meta_channel_subscribed') === 'true' ||
          (u && (u.channel_subscribed === 1 || u.channel_subscribed === true || u.channel_subscribed === 'true' || u.channel_subscribed === '1'))) {
        return [1, 2, 3, 4];
      }

      // День 1 всегда открыт для зарегистрированного участника
      if (!u || (!u.has_paid && !u.hasPaid && localStorage.getItem('meta_paid_all_days') !== 'true')) {
        return [1];
      }

      const raw = localStorage.getItem(STORAGE_UNLOCKED_DAYS);
      const arr = raw ? JSON.parse(raw) : [];
      const parsed = Array.isArray(arr) ? arr.map(Number).filter(n => !isNaN(n)) : [];
      const set = new Set(parsed);
      [1, 2, 3, 4].forEach(d => {
        if (localStorage.getItem(`meta_paid_day_${d}`) === 'true') set.add(d);
      });
      return Array.from(set);
    } catch (e) {
      return [];
    }
  }

  function unlockDayLocally(dayNumber) {
    const num = Number(dayNumber);
    const days = getUnlockedDays();
    if (!days.includes(num)) {
      days.push(num);
      localStorage.setItem(STORAGE_UNLOCKED_DAYS, JSON.stringify(days));
    }
  }

  function isDayUnlocked(dayNumber) {
    const num = Number(dayNumber);

    // День 1 всегда открыт для всех (бесплатный вводный интенсив)
    if (num === 1) return true;

    // Для незарегистрированных пользователей остальные дни строго закрыты
    if (typeof isRegistered === 'function' && !isRegistered()) return false;
    const u = (typeof getUser === 'function') ? getUser() : null;
    if (!u) return false;

    // При подтвержденной подписке на закрытый канал - ВСЕ 4 ДНЯ ОТКРЫТЫ МГНОВЕННО БЕЗ ОЖИДАНИЯ
    if ((typeof isChannelSubscribed === 'function' && isChannelSubscribed()) ||
        localStorage.getItem('meta_channel_subscribed') === 'true' ||
        (u && (u.channel_subscribed === 1 || u.channel_subscribed === true || u.channel_subscribed === 'true' || u.channel_subscribed === '1'))) {
      return true;
    }

    if (window.location.search.indexOf('dev_unlock_all=1') !== -1) return true;

    // Строгий гейт: без подписки на закрытый канал ВСЕ дни строго закрыты (если не куплены)
    if (localStorage.getItem('meta_paid_all_days') === 'true') return true;
    if (localStorage.getItem(`meta_paid_day_${num}`) === 'true') return true;
    if (u.has_paid || u.hasPaid) return true;

    return false;
  }
  window.isDayUnlocked = isDayUnlocked;
  window.getUnlockedDays = getUnlockedDays;

  // Список приглашенных подруг
  function getInvitedFriends() {
    try {
      const raw = localStorage.getItem(STORAGE_INVITED_FRIENDS);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function addInvitedFriend(name, dayNumber = null) {
    const friends = getInvitedFriends();
    friends.unshift({
      name: name || 'Друг',
      date: new Date().toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }),
      day: dayNumber ? `День ${dayNumber}` : 'Интенсив'
    });
    localStorage.setItem(STORAGE_INVITED_FRIENDS, JSON.stringify(friends.slice(0, 10)));
  }

  // Количество приглашенных друзей
  function getReferralCount() {
    try {
      const val = parseInt(localStorage.getItem(STORAGE_REF_COUNT) || '0', 10);
      return isNaN(val) ? 0 : val;
    } catch (e) {
      return 0;
    }
  }

  function setReferralCount(count) {
    const num = Math.max(0, parseInt(count, 10) || 0);
    localStorage.setItem(STORAGE_REF_COUNT, String(num));
    updateReferralUI();
  }

  // Получение параметров реферала/источника из URL (Telegram Mini App)
  function getSourceParam() {
    const urlParams = new URLSearchParams(window.location.search || '');
    const startParam = urlParams.get('start') || urlParams.get('startapp') || urlParams.get('ref') || urlParams.get('tgWebAppStartParam');
    if (startParam) return startParam;

    if (window.location.hash) {
      let rawHash = window.location.hash.replace(/^#/, '').trim();
      try {
        rawHash = decodeURIComponent(rawHash);
      } catch (e) {}

      const hashParams = new URLSearchParams(rawHash.includes('?') ? rawHash.split('?')[1] : rawHash);
      const hashParamVal = hashParams.get('ref') || hashParams.get('start') || hashParams.get('startapp');
      if (hashParamVal) {
        const clean = hashParamVal.replace('#', '').trim();
        if (clean) return clean;
      }

      if (rawHash.startsWith('ref_')) return rawHash;
      if (rawHash.startsWith('paid_') || rawHash === 'paid_all' || rawHash.includes('paid')) return rawHash;
      if (rawHash.startsWith('start=')) return rawHash.replace('start=', '');
      if (rawHash.startsWith('startapp=')) return rawHash.replace('startapp=', '');

      const refMatch = rawHash.match(/ref_[a-zA-Z0-9_-]+/);
      if (refMatch) return refMatch[0];

      const paidMatch = rawHash.match(/paid_[a-zA-Z0-9_-]+/);
      if (paidMatch) return paidMatch[0];
    }

    if (window.location.search) {
      const searchRefMatch = window.location.search.match(/ref_[a-zA-Z0-9_-]+/);
      if (searchRefMatch) return searchRefMatch[0];
    }

    const tg = window.Telegram?.WebApp;
    if (tg?.initDataUnsafe?.start_param) {
      return tg.initDataUnsafe.start_param;
    }
    return 'direct';
  }

  // Захват и сохранение UTM-параметров и меток клика для сквозной аналитики
  function captureUtmParams() {
    try {
      const urlParams = new URLSearchParams(window.location.search || '');
      let uSrc = urlParams.get('utm_source');
      let uMed = urlParams.get('utm_medium');
      let uCmp = urlParams.get('utm_campaign');
      let uCnt = urlParams.get('utm_content');
      let uTrm = urlParams.get('utm_term');
      let yclid = urlParams.get('yclid') || urlParams.get('ym_client_id');
      let gclid = urlParams.get('gclid');
      let vkclid = urlParams.get('vkclid');

      const tg = window.Telegram?.WebApp;
      const startParam = tg?.initDataUnsafe?.start_param || urlParams.get('tgWebAppStartParam') || '';
      if (!uSrc && startParam && startParam.startsWith('utm')) {
        const parts = startParam.includes('__') ? startParam.split('__') : startParam.split('_');
        if (parts.length > 1) uSrc = parts[1];
        if (parts.length > 2) uMed = parts[2];
        if (parts.length > 3) uCmp = parts[3];
        if (parts.length > 4) uCnt = parts[4];
        if (parts.length > 5) uTrm = parts[5];
      }

      if (uSrc || uMed || uCmp || uCnt || uTrm || yclid || gclid || vkclid) {
        const utmData = {
          utm_source: uSrc || '',
          utm_medium: uMed || '',
          utm_campaign: uCmp || '',
          utm_content: uCnt || '',
          utm_term: uTrm || '',
          yclid: yclid || '',
          gclid: gclid || '',
          vkclid: vkclid || ''
        };
        localStorage.setItem('meta_utm_data', JSON.stringify(utmData));
        return utmData;
      }

      const stored = localStorage.getItem('meta_utm_data');
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }

  // Сохранение регистрации в базу данных (с фоновым дублем в Google Таблицу)
  async function saveUserRegistration(payload) {
    const utms = captureUtmParams();
    if (utms.utm_source) payload.utm_source = utms.utm_source;
    if (utms.utm_medium) payload.utm_medium = utms.utm_medium;
    if (utms.utm_campaign) payload.utm_campaign = utms.utm_campaign;
    if (utms.utm_content) payload.utm_content = utms.utm_content;
    if (utms.utm_term) payload.utm_term = utms.utm_term;
    if (utms.yclid) payload.yclid = utms.yclid;

    const jsonBody = JSON.stringify(payload);
    
    // 1. Быстрое сохранение в API сервера (FastAPI + SQLite)
    try {
      const apiRes = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: jsonBody
      });

      if (apiRes.ok) {
        try {
          const resData = await apiRes.json();
          if (resData && resData.user) {
            const u = resData.user;
            if (typeof u.bonus_balance === 'number') {
              localStorage.setItem(STORAGE_BONUS_BALANCE, String(u.bonus_balance));
            }
            if (typeof u.referral_count === 'number') {
              localStorage.setItem(STORAGE_REF_COUNT, String(u.referral_count));
            }
            if (u.unlocked_days) {
              const days = typeof u.unlocked_days === 'string' ? JSON.parse(u.unlocked_days) : u.unlocked_days;
              localStorage.setItem(STORAGE_UNLOCKED_DAYS, JSON.stringify(days));
            }
            if (Array.isArray(u.invited_friends)) {
              localStorage.setItem(STORAGE_INVITED_FRIENDS, JSON.stringify(u.invited_friends));
            }
            if (u.has_paid) {
              localStorage.setItem('meta_paid_all_days', 'true');
            }
            if (u.telegram_id) {
              localStorage.setItem('meta_tg_user_id', String(u.telegram_id));
            }
            if (u.channel_subscribed === 1 || u.channel_subscribed === true || u.channel_subscribed === 'true' || u.channel_subscribed === '1') {
              localStorage.setItem('meta_channel_subscribed', 'true');
              localStorage.setItem(STORAGE_UNLOCKED_DAYS, JSON.stringify([1, 2, 3, 4]));
            }
            if (u.id) {
              localStorage.setItem('meta_user_id', String(u.id));
              if (typeof setSessionCookie === 'function') {
                setSessionCookie('meta_user_id', String(u.id));
              }
            }
            if (typeof setSessionCookie === 'function') {
              setSessionCookie('meta_user_registered', 'true');
            }
            const curUser = getUser() || {};
            curUser.id = u.id || curUser.id;
            curUser.name = u.name || curUser.name;
            curUser.phone = u.phone || curUser.phone;
            curUser.email = u.email || curUser.email;
            curUser.telegramId = u.telegram_id || curUser.telegramId;
            curUser.telegram_id = u.telegram_id || curUser.telegram_id;
            curUser.channel_subscribed = u.channel_subscribed ?? curUser.channel_subscribed;
            curUser.bonus = u.bonus_balance ?? curUser.bonus;
            curUser.registered = true;
            inMemoryUser = curUser;
            window.__metaUser = curUser;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(curUser));
            localStorage.setItem(REGISTERED_FLAG, 'true');
            console.log('[MetaOnboarding] Успешно сохранено в базу данных SQLite, id:', u.id);
            return { ok: true, user: u, userId: u.id };
          }
        } catch (e) {}
        console.log('[MetaOnboarding] Успешно сохранено в базу данных SQLite');
        return { ok: true };
      }
    } catch (e) {
      console.warn('[MetaOnboarding] Ошибка при обращении к серверу:', e);
    }
    return { ok: false };
  }

  const sendToGoogleSheet = saveUserRegistration;


  const STORAGE_BONUS_BALANCE = 'meta_bonus_balance';

  function getBonusBalance() {
    try {
      const stored = localStorage.getItem(STORAGE_BONUS_BALANCE);
      if (stored !== null && stored !== '') {
        return parseInt(stored, 10) || 0;
      }
      if (isRegistered()) {
        const u = getUser();
        if (u && typeof u.bonus === 'number') {
          localStorage.setItem(STORAGE_BONUS_BALANCE, String(u.bonus));
          return u.bonus;
        }
        return 0;
      }
      return 0;
    } catch (e) {
      return 0;
    }
  }

  function setBonusBalance(val) {
    localStorage.setItem(STORAGE_BONUS_BALANCE, String(val));
    updateBonusUI();
  }

  function updateBonusUI() {
    const total = getBonusBalance();
    document.querySelectorAll('#bonusBalanceValue').forEach(el => {
      el.textContent = `${total.toLocaleString('ru-RU')} ₽`;
    });
  }

  // Создание модального окна прямой регистрации в DOM